import { render } from "./TrainingRecord.vue?vue&type=template&id=03abafdb&scoped=true"
import script from "./TrainingRecord.vue?vue&type=script&lang=js"
export * from "./TrainingRecord.vue?vue&type=script&lang=js"

import "./TrainingRecord.vue?vue&type=style&index=0&id=03abafdb&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\sport.yanhuotiyu.com焱火pc端web网站\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03abafdb"]])

export default __exports__